// Gratis reim med klokke (Simpleness, 2026-10)
// Velgeren åpnes når kunden trykker «Legg i kurv» på en klokke (mode="pdp"), eller fra påminnelsen i handlekurven
// (mode="cart"). Prisen settes av den automatiske rabatten «Gratis reim med klokke»; her legges bare varene i kurven.

const ROOT = window.Shopify?.routes?.root || "/";
const BYTT_FLAGG = "gratis-reim-apne";

function bundledSections(extra = []) {
  const sections = [...extra];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } }));
  return sections;
}

function erKurvside() {
  return window.themeVariables?.settings?.pageType === "cart" || window.themeVariables?.settings?.cartType === "page";
}

async function sendKurvEndring(baseEvent, sectionsResponse) {
  const cart = await (await fetch(`${ROOT}cart.js`)).json();
  cart.sections = sectionsResponse;
  document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent, cart } }));
  return cart;
}

// Gjør om produktskjemaets felter (id, quantity, properties[...], selling_plan) til et item for /cart/add.js
function itemFraSkjema(form) {
  const data = new FormData(form);
  const item = { id: Number(data.get("id")), quantity: Number(data.get("quantity") || 1), properties: {} };
  for (const [navn, verdi] of data.entries()) {
    const treff = navn.match(/^properties\[(.+)\]$/);
    if (treff && verdi !== "") item.properties[treff[1]] = verdi;
  }
  if (data.get("selling_plan")) item.selling_plan = Number(data.get("selling_plan"));
  return item;
}

class GratisReimVelger extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector("dialog");
    this.leggTilKnapp = this.querySelector(".gr-foot .button");
    this.mode = this.getAttribute("mode");

    this.addEventListener("click", this._onClick);
    this.dialog.addEventListener("click", (e) => { if (e.target === this.dialog) this.lukk(); });
    this.dialog.addEventListener("close", () => document.documentElement.classList.remove("gr-lock"));
    this.leggTilKnapp?.addEventListener("click", () => this._leggTil());
    this._oppdaterValgt();

    if (this.mode === "pdp") {
      this.form = document.getElementById(this.getAttribute("form"));
      this._onSubmit = this._onSubmit.bind(this);
      // Capture på document kjører før temaets egen submit-lytter på skjemaet
      document.addEventListener("submit", this._onSubmit, true);
    }

    if (this.mode === "cart") {
      this.closest(".gr-remind-wrap")?.querySelector("[data-gr-apne]")?.addEventListener("click", () => this.apne());
      try {
        if (sessionStorage.getItem(BYTT_FLAGG)) {
          sessionStorage.removeItem(BYTT_FLAGG);
          requestAnimationFrame(() => this.apne());
        }
      } catch (e) {}
    }
  }

  disconnectedCallback() {
    if (this._onSubmit) document.removeEventListener("submit", this._onSubmit, true);
  }

  _onSubmit(event) {
    if (event.target !== this.form || this._slippGjennom || !this.isConnected) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    this.apne();
  }

  apne() {
    document.documentElement.classList.add("gr-lock");
    this.dialog.showModal();
    this.querySelector(".gr-card.is-selected")?.scrollIntoView({ block: "nearest" });
  }

  lukk() {
    this.dialog.close();
  }

  _onClick(event) {
    const filter = event.target.closest("[data-gr-filter]");
    if (filter) return this._filtrer(filter.dataset.grFilter);

    const kort = event.target.closest("button.gr-card");
    if (kort) {
      this.querySelectorAll("button.gr-card").forEach((k) => {
        k.classList.toggle("is-selected", k === kort);
        k.setAttribute("aria-pressed", k === kort ? "true" : "false");
      });
      return this._oppdaterValgt();
    }

    if (event.target.closest("[data-gr-lukk]")) return this.lukk();
    if (event.target.closest("[data-gr-hopp-over]")) return this._hoppOver();
  }

  _filtrer(type) {
    this.querySelectorAll("[data-gr-filter]").forEach((p) => {
      const on = p.dataset.grFilter === type;
      p.classList.toggle("is-on", on);
      p.setAttribute("aria-pressed", on ? "true" : "false");
    });
    this.querySelectorAll(".gr-card").forEach((k) => (k.hidden = type !== "Alle" && k.dataset.grType !== type));
    const desc = this.querySelector("[data-gr-desc]");
    if (desc) desc.textContent = desc.dataset[type.toLowerCase()] || "";
    this.querySelector(".gr-body").scrollTop = 0;
  }

  _oppdaterValgt() {
    const valgt = this.querySelector("button.gr-card.is-selected");
    this.querySelector("[data-gr-selected-name]").textContent = valgt?.dataset.grName || "";
    this.querySelector("[data-gr-selected-price]").textContent = valgt?.dataset.grPrice || "";
  }

  _hoppOver() {
    this.lukk();
    if (this.mode !== "pdp") return;
    this._slippGjennom = true;
    this.form.requestSubmit();
    this._slippGjennom = false;
  }

  _travel(aktiv) {
    if (!this.leggTilKnapp) return;
    this.leggTilKnapp.toggleAttribute("disabled", aktiv);
    this.leggTilKnapp.setAttribute("aria-busy", aktiv ? "true" : "false");
  }

  async _leggTil() {
    const valgt = this.querySelector("button.gr-card.is-selected");
    if (!valgt) return;
    const reim = { id: Number(valgt.dataset.grVariant), quantity: 1, properties: { _gratis_reim: "Ja" } };

    this._travel(true);
    try {
      if (this.mode === "pdp") {
        await this._leggTilKlokkeOgReim(reim);
      } else {
        await this._leggTilReim(reim);
      }
    } finally {
      this._travel(false);
    }
  }

  async _leggTilKlokkeOgReim(reim) {
    const klokke = itemFraSkjema(this.form);
    const sections = bundledSections(["variant-added"]);
    const response = await fetch(`${ROOT}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [klokke, reim], sections: sections.join(","), sections_url: `${ROOT}variants/${klokke.id}` })
    });
    const json = await response.json();
    this.lukk();

    if (!response.ok) {
      this.form.dispatchEvent(new CustomEvent("cart:error", { bubbles: true, detail: { error: json.description || json.message } }));
      return;
    }
    if (erKurvside()) return (window.location.href = `${ROOT}cart`);

    const cart = await (await fetch(`${ROOT}cart.js`)).json();
    cart.sections = json.sections;
    this.form.dispatchEvent(new CustomEvent("variant:add", { bubbles: true, detail: { items: json.items || [json], cart } }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: { baseEvent: "variant:add", cart } }));
  }

  async _leggTilReim(reim) {
    const sections = bundledSections();
    const response = await fetch(`${ROOT}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [reim], sections: sections.join(",") })
    });
    const json = await response.json();
    this.lukk();
    if (!response.ok) return;
    if (erKurvside()) return window.location.reload();
    await sendKurvEndring("variant:add", json.sections);
  }
}

// Fjerner gratisreimer som ikke lenger har en klokke i kurven (beregnet i gratis-reim-kurv.liquid)
class GratisReimRydd extends HTMLElement {
  async connectedCallback() {
    if (GratisReimRydd.kjorer) return;
    let updates;
    try { updates = JSON.parse(this.dataset.updates); } catch (e) { return; }
    if (!updates || !Object.keys(updates).length) return;

    GratisReimRydd.kjorer = true;
    try {
      if (erKurvside()) {
        await fetch(`${ROOT}cart/update.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates }) });
        return window.location.reload();
      }
      const sections = bundledSections();
      const json = await (await fetch(`${ROOT}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates, sections })
      })).json();
      const cart = await sendKurvEndring("variant:add", json.sections);
      // Tom kurv: temaets tom-tilstand tegnes ikke alltid fra cart:change, så tving full omtegning
      if (cart.item_count === 0) document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    } finally {
      GratisReimRydd.kjorer = false;
    }
  }
}

// «Bytt reim»: linja fjernes av temaets egen fjern-lenke; velgeren åpnes når kurven er tegnet på nytt
document.addEventListener("click", (event) => {
  if (event.target.closest("[data-gr-bytt]")) {
    try { sessionStorage.setItem(BYTT_FLAGG, "1"); } catch (e) {}
  }
}, true);

if (!customElements.get("gratis-reim-velger")) customElements.define("gratis-reim-velger", GratisReimVelger);
if (!customElements.get("gratis-reim-rydd")) customElements.define("gratis-reim-rydd", GratisReimRydd);
